import { TasksInfiniteView } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components/tasks-infinite'
import { TasksTableView } from '@apps-common/apps/portal/pages/units/pages/program-tasks/components/tasks-table'
import { MobileViewSwitcher } from '@apps-common/components/common/MobileViewSwitcher'

export const TasksView = () => <MobileViewSwitcher desktopView={<TasksTableView />} mobileView={<TasksInfiniteView />} />
